export const IC_MAINNET_HOST = "https://ic0.app";
export const IC_LOCAL_HOST = "https://8000-icnaming-namearkdapp-z5uvexx15nk.ws.gitpod.nicepod.xyz";
